import { UIElement } from './uiElement';
import { Event } from '../..';
import { CSS } from '../../../const';
import { IEvent } from '../../../interfaces';
import { IUIElementOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';

export class Button extends UIElement<string> {
	private icon: string;
	private buttonCss: KnockoutComputed<string>;
	protected click: () => void;
	protected onClick: Event<void>;
	public get Clicked(): IEvent<void> {
		return this.onClick;
	}
	constructor(id: string, label: string, icon: string = '', options?: IUIElementOptions) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				template: Templates.layouts_uiElements_buttonWidget,
				widget: {
					widget: Templates.widgets_button
				}
			},
			options || {}
		);
		super(id, label, null, options);
		this.onClick = new Event<void>();
		this.click = () => {
			if (this.editable()) {
				this.onClick.notify();
			}
		};
		this.icon = icon;
		this.buttonCss = ko.pureComputed(() => {
			return this.icon.concat(' ', this.editable() ? '' : CSS.Disabled);
		});
	}
}
